/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlignBoxCenterMiddle = createReactComponent("outline", "align-box-center-middle", "IconAlignBoxCenterMiddle", [["path", { "d": "M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M11 15h2", "key": "svg-1" }], ["path", { "d": "M9 12h6", "key": "svg-2" }], ["path", { "d": "M10 9h4", "key": "svg-3" }]]);

export { IconAlignBoxCenterMiddle as default };
//# sourceMappingURL=IconAlignBoxCenterMiddle.mjs.map
